module.exports = __webpack_public_path__ + "img/fireIcon.636fb3ff.png";